import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";

const BASE = "api/admin/lead-campaigns";

const request = async (url, method = "GET", data) => {
  try {
    const response = await api.request({
      url,
      method,
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    const res = error?.response?.data;
    if (res) return res;
    throw error;
  }
};

const normalize = (res, fallbackMessage) => {
  const isSuccess = res?.isSuccess ?? res?.IsSuccess;
  if (!res || isSuccess === false) {
    return {
      error: res?.message || res?.Message || fallbackMessage,
      data: null,
      statusCode: res?.statusCode ?? res?.StatusCode,
    };
  }
  return {
    error: null,
    data: res.data ?? res.Data ?? res,
    statusCode: res?.statusCode ?? res?.StatusCode,
  };
};

const withPaging = (params = {}) => {
  const q = queryString.stringify({
    page: params.page || 1,
    pageSize: params.pageSize || 20,
    ...(params.sendStatus != null && params.sendStatus !== "" ? { sendStatus: params.sendStatus } : {}),
    ...(params.registeredAfterSend != null && params.registeredAfterSend !== ""
      ? { registeredAfterSend: params.registeredAfterSend }
      : {}),
    ...(params.projectRequestedAfterSend != null && params.projectRequestedAfterSend !== ""
      ? { projectRequestedAfterSend: params.projectRequestedAfterSend }
      : {}),
    ...(params.mobile ? { mobile: params.mobile } : {}),
  });
  return q ? `?${q}` : "";
};

const LeadCampaignApi = {
  getDashboard: () => request(`${BASE}/dashboard`),
  getGroups: (params) => request(`${BASE}/groups${withPaging(params)}`),
  getGroupById: (id) => request(`${BASE}/groups/${id}`),
  createGroup: (payload) => request(`${BASE}/groups`, "POST", payload),
  updateGroup: (id, payload) => request(`${BASE}/groups/${id}`, "PUT", payload),
  patchGroupStatus: (id, isActive) =>
    request(`${BASE}/groups/${id}/status`, "PATCH", { isActive }),
  deleteGroup: (id) => request(`${BASE}/groups/${id}`, "DELETE"),
  getGroupContacts: (groupId, params) =>
    request(`${BASE}/groups/${groupId}/contacts${withPaging(params)}`),
  updateContact: (groupId, contactId, payload) =>
    request(`${BASE}/groups/${groupId}/contacts/${contactId}`, "PUT", payload),
  deleteContact: (groupId, contactId) =>
    request(`${BASE}/groups/${groupId}/contacts/${contactId}`, "DELETE"),
  importContacts: (groupId, rawText) =>
    request(`${BASE}/groups/${groupId}/contacts/import`, "POST", { rawText }),
  getCampaigns: (params) => request(`${BASE}/campaigns${withPaging(params)}`),
  getCampaignById: (id) => request(`${BASE}/campaigns/${id}`),
  createCampaign: (payload) => request(`${BASE}/campaigns`, "POST", payload),
  updateCampaign: (id, payload) => request(`${BASE}/campaigns/${id}`, "PUT", payload),
  patchCampaignStatus: (id, status) =>
    request(`${BASE}/campaigns/${id}/status`, "PATCH", { status }),
  getGroupPerformance: (groupId) => request(`${BASE}/groups/${groupId}/performance`),
  getCampaignPerformance: (campaignId) =>
    request(`${BASE}/campaigns/${campaignId}/performance`),
  getFunnel: () => request(`${BASE}/funnel`),
  getFunnelByCampaign: () => request(`${BASE}/funnel-by-campaign`),
  getFunnelByGroup: () => request(`${BASE}/funnel-by-group`),
  prepareBatch: (campaignId, payload) =>
    request(`${BASE}/campaigns/${campaignId}/prepare-batch`, "POST", payload),
  getCampaignRecipients: (campaignId, params) =>
    request(`${BASE}/campaigns/${campaignId}/recipients${withPaging(params)}`),
  getReports: () => request(`${BASE}/reports`),
  sendCampaign: (campaignId, payload = {}) =>
    request(`${BASE}/campaigns/${campaignId}/send`, "POST", payload),
  normalize,
};

export default LeadCampaignApi;
